module.exports = __webpack_public_path__ + "static/media/xg.2bbd872f.png";